export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/dof-accordion/index.js